import { ProductDetailSlotsDTO, PaymentReinsuranceDTO } from './ProductDetailSlotsDTO';
import { ProductDetailSlotsDTOTypes } from './ProductDetailSlotsTypes';

export type DeliveryAndReturnsInfosContentValue = {
    content?: string;
};

export const mapDeliveryAndReturnsInfosContent = (dto: ProductDetailSlotsDTO): DeliveryAndReturnsInfosContentValue => {
    const deliveryInfosContent = dto.slots.find(
        (slot) => slot.type === ProductDetailSlotsDTOTypes.deliveryAndReturnsInfosContent.value,
    );

    return {
        content: deliveryInfosContent?.details.items[0].description,
    };
};

export type PaymentMethodsValue = {
    items?: { name: string }[];
    paymentMethodsUrl?: string | null;
};

export const mapPaymentMethods = (dto: ProductDetailSlotsDTO): Partial<PaymentMethodsValue> => {
    return dto.slots.reduce<Partial<PaymentMethodsValue>>(
        (acc, slot) => {
            return {
                items:
                    slot.type === ProductDetailSlotsDTOTypes.paymentReinsurance.value
                        ? mapPaymentMethodsItems(slot)
                        : acc.items,
            };
        },
        {
            items: [],
        },
    );
};

export const mapPaymentMethodsItems = (dto: PaymentReinsuranceDTO): { name: string }[] => {
    return dto.details.items.map(({ name }) => ({ name }));
};
